import { AssistantOutlined } from '@mui/icons-material';

import Button from '@/components/Buttons/Button';

const AskGXButton = ({
  onClick
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    <Button
      color='primary'
      size='large'
      startIcon={<AssistantOutlined />}
      sx={{
        whiteSpace: 'nowrap',
        minWidth: 192
      }}
      variant='contained'
      onClick={onClick}
    >
      GX Go Assistant
    </Button>
  );
};

export default AskGXButton;
